<template>
  <div class="animated fadeIn">
    <b-card>
      <b-form id="spkbForm" validated novalidate>
        <b-row>
          <b-col lg="12">
            <template>
              <b-row>
                <b-col sm="4">
                  <b-form-group label-for="month" label="Penanggung Jawab Faktur">
                    <b-form-select
                      id="pic"
                      v-model="pic"
                      required
                      @input="onSelect"
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                      <option
                        v-for="(item, index) in listDriverEmployee"
                        :key="uniqueId('employee_list'+index)"
                        :value="{code:'employee', value:item.value}"
                      >{{item.text}}</option>
                      <option
                        v-for="(item, index) in listDistributionCenter"
                        :key="uniqueId('dc_list'+index)"
                        :value="{code:'distribution_center', value:item.value}"
                      >{{item.text}}</option>
                    </b-form-select>
                    <b-form-invalid-feedback>Penanggung jawab faktur harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>

                <b-col sm="4">
                  <b-form-group label-for="date" label="Tanggal Pengiriman">
                    <v-date-picker
                      mode="range"
                      id="date"
                      required
                      :input-props="{ class: 'form-control', placeholder: 'Tanggal Pengiriman', required: '', readonly: ''}"
                      v-model="myDate"
                    ></v-date-picker>
                  </b-form-group>
                </b-col>

                <b-col sm="4" v-if="showHoreka">
                  <b-form-group label-for="month" label="Horeka">
                    <b-form-select
                      id="horeka"
                      v-model="horeka"
                      required
                    >
                      <template slot="first">
                        <option :value="null" disabled>-- Harap pilih salah satu --</option>
                      </template>
                      <option
                        v-for="(item, index) in listCustomerHoreka"
                        :key="uniqueId('customer_list'+index)"
                        :value="{code:'customer', value:item.value}"
                      >{{item.text}}</option>
                     
                    </b-form-select>
                    <b-form-invalid-feedback>Horeka harus di pilih.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-button size="sm" variant="stack-overflow" class="mr-1 btn-brand" @click="getDetail" :disabled="disabled">
              <i class="fa fa-search"></i>
              <span>Filter</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-card size="sm">
      <div slot="header">
        <i class="icon-note"></i> Lakukan Pembayaran Untuk SPKB Tempo
      </div>
      <b-card-body>
        <finance-payment-detail-tempo
          :loading="loading"
          :pic="pic"
          :listSpkb="listSpkb"
          :listBank="listBank"
          :paymentForm="paymentForm"
          :total_all_payment="total_all_payment"
          @reload="reset"
          @calulateTotal="updateTotal"
          @processPayment="processPayment"
        ></finance-payment-detail-tempo>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { ModelSelect } from "vue-search-select";
import axios from "axios";
import financePaymentDetailTempo from "./PaymentDetailTempo";
import interfaces from "@/templates/_interfaces.js";
import { required, between } from "vuelidate/lib/validators";
import loading from "@/templates/Loading.vue";
import _ from "lodash";
import * as moment from "moment";
import "moment/locale/id";

export default {
  name: "finance-payment",
  components: {
    ModelSelect,
    loading,
    financePaymentDetailTempo
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      listDriverEmployee: [],
      listDistributionCenter: [],
      listCustomerHoreka: [],
      listBank: [],
      paymentForm: interfaces.payment,
      pic: null,
      horeka: null,
      showHoreka: false,
      myDate: null,
      loading: false,
      listSpkb: [],
      total_all_payment: 0
    };
  },
  computed: {
    disabled: function() {
      let temp1 = true;
      let temp2 = true;

      if(this.pic !== null && this.pic.value !== '49') {
        temp1 = false;
      } else if(this.pic !== null && this.pic.value === '49') {
        if(this.horeka === null) {
          temp1 = true;
        } else {
          temp1 = false;
        }
      }

      if(this.myDate !== null) {
        temp2 = false;
      } else {
        temp2 = true;
      }

      return (temp1 === false && temp2 === false) ? false : true;
    }
  },
  validations: {

  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    uniqueId: function(param = "") {
      return _.uniqueId(param);
    },
    getDetail: function() {
      this.loading = true;
      let start = moment(this.myDate.start).format("YYYY-MM-DD");
      let end = moment(this.myDate.end).format("YYYY-MM-DD");

      this.axios
        .post("web/finance/list-detail-product-tempo/", {'pic': this.pic, 'horeka': this.horeka, 'delivery_start': start, 'delivery_end': end, 'spkb_type': 2})
        .then(response => {
          //this.paymentForm = interfaces.payment;
          this.reset();
          this.listSpkb = response.data.data;
          this.listSpkb.forEach((value, index, element) => {
            this.paymentForm.total_payment['total_'+value.order_number]= null;
            this.paymentForm.total_amount[index] = {order_number: value.order_number, amount: value.amount};
          });
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    },
    back: function() {
      this.$router.go(-1);
    },
    getDropdownSpkb: function() {
      this.axios
        .get("web/dropdown/dropdown-spkb/")
        .then(response => {
          this.listDriverEmployee = response.data.driver;
          this.listDistributionCenter = response.data.distribution_center;
          this.listCustomerHoreka = response.data.customer_horeka;
          this.listBank = response.data.bank;
        })
        .catch(error => {})
        .finally(() => {
          //this.loading = false;
        });
    },
    onSelect: function(data) {
      if(data.value === '49') {
        this.showHoreka = true;
        this.horeka = null;
      } else {
        this.showHoreka = false;
        this.horeka = null;
      }
    },
    reset: function() {
      //this.paymentForm = interfaces.payment;
      this.paymentForm.action = [];
      this.paymentForm.total_payment = [],
      this.paymentForm.bank = null;
      this.paymentForm.payment_date = null;
      this.total_all_payment = 0;
    },
    updateTotal: function(newTotal) {
      this.total_all_payment = parseInt(newTotal);
    },
    processPayment: function(data) {
      this.loading = true;
      //console.log(data);
      let total_payment = [];
      for (let key in data.total_payment){
        if(data.total_payment[key] !== null) {
          total_payment.push(key+'#'+data.total_payment[key]);
        }
      }
      data.total_payment = total_payment;
      data.payment_date = moment(data.payment_date).format("YYYY-MM-DD");
      this.axios
        .post("web/finance/process_payment_tempo/", {'data': data})
        .then(response => {
          if (response.data.status === 2000) {
              this.showInfoNotification({
                title: "Payment",
                message: response.data.message
              });
            }
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.expired(error, "");
          }
        })
        .finally(() => {
          this.getDetail();
          this.loading = false;
        });
    }
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.spkb_number = route[4];
    this.getDropdownSpkb();
  }
};
</script>

<style>
</style>